<form *ngIf="withdrawForm" #f="ngForm" [formGroup]="withdrawForm" class="p-3">
  <div class="row align-items-center justify-content-between">
    <div class="form-group col-lg-3">
      <label class="mb-2">{{ 'Sellers.Dashboard.RequiredAmount' | translate }}: </label>
      <span class="mandatory"></span>
      <input type="number" min="1" class="form-control"
             placeholder="{{ 'Sellers.Products.EnterAmountEGP' | translate }}"
             formControlName="required_amount" required #rm>
    </div>
    <div class="col-lg-2 text-center">
      <button class="btn btn-primary"
              type="submit" id="submit" value="Submit" (click)="onWithdrawl()"
              [disabled]="withdrawForm.invalid">
        {{ 'Sellers.Products.Submit' | translate }}
      </button>
    </div>

  </div>
</form>
